// removed by extract-text-webpack-plugin
module.exports = {"container":"_1xDTIXJbwWT0h8uXBhqapT","Email":"_1q1CFyJu9wB64vF_jVlmZy","Signer":"n4hiBEHF3M36XdsNIu8A3","Icon":"_3Gu0BWXpq-flRTlA5Nzta5","Title":"V-wEuMRn2T1-oPT6z5eY2"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/PubDocumentVerify/DocVerifier/Verify/Signers/styles.css
// module id = 3019
// module chunks = 0